import React, {
  createContext,
  useContext,
  useLayoutEffect,
  useMemo,
  useState
} from "react";
import { matchPath } from "react-router-dom";
import { isKidsMenu } from "./kidsTheme";
import "./KidsChrome.scss";

const CatalogThemeContext = createContext({ isKids: false, setMenu: () => {} });
export const useCatalogTheme = () => useContext(CatalogThemeContext);

// Scope the theme to the displayed catalogue route. Detail overlays retain their
// background route, while leaving Kids clears the theme before the next request.
export function CatalogShell({ location, children }) {
  const [menu, setMenu] = useState(null);
  const route = matchPath(location.pathname, {
    path: "/dashboard/home/:menuId/:categoryId"
  });
  const isKids =
    !!route && route.params.menuId === menu?.id && isKidsMenu(menu?.name);
  const value = useMemo(() => ({ isKids, setMenu }), [isKids]);
  return (
    <CatalogThemeContext.Provider value={value}>
      <div className={`atlas-shell${isKids ? " kids-shell" : ""}`}>
        {children}
      </div>
    </CatalogThemeContext.Provider>
  );
}

export function useCatalogMenuTheme(id, name) {
  const { setMenu } = useCatalogTheme();
  useLayoutEffect(() => {
    if (id) setMenu({ id, name });
  }, [id, name, setMenu]);
}
